import { ChipMenu, MenuItemProps, useListFilterState } from "@mzara/component";
import { useCallback } from "react";
import { useStateFilterMenuItems } from "../hooks/useStateFilterMenuItems";
import { useAdvertFilterMenuItems } from "../hooks/useAdvertFilterMenuItems";
import { useCVFilterMenuItems } from "../hooks/useCVFilterMenuItems";

const ListFilterDropdownButtonGroups = ({
    listId,
}: ListFilterDropdownButtonGroupsProps) => {
    const { filter, setFilter } = useListFilterState(listId);

    const stateFilterMenuItems = useStateFilterMenuItems();
    const advertFilterMenuItems = useAdvertFilterMenuItems();
    const cvFilterMenuItems = useCVFilterMenuItems();

    const handleApplicationFilterClick = useCallback(
        (menu: MenuItemProps) => {
            setFilter((v: any) => ({
                ...v,
                data: {
                    ...v.data,
                    curiculumVitae:
                        menu.id !== 0
                            ? {
                                  id: menu.id,
                              }
                            : {},
                },
            }));
        },
        [setFilter]
    );

    const handleAdvertFilterClick = useCallback(
        (menu: MenuItemProps) => {
            setFilter((v: any) => ({
                ...v,
                data: {
                    ...v.data,
                    recruitingAdvert:
                        menu.id !== 0
                            ? {
                                  id: menu.id,
                              }
                            : {},
                },
            }));
        },
        [setFilter]
    );

    const handleStateFilterClick = useCallback(
        (menu: MenuItemProps) => {
            setFilter((v: any) => ({
                ...v,
                data: {
                    ...v.data,
                    state: menu.value,
                },
            }));
        },
        [setFilter]
    );

    return (
        <div className="flex items-center gap-2">
            <ChipMenu
                value={filter.data?.curiculumVitae?.id}
                items={cvFilterMenuItems}
                onClick={handleApplicationFilterClick}
            />

            <ChipMenu
                value={filter.data?.recruitingAdvert?.id}
                items={advertFilterMenuItems}
                onClick={handleAdvertFilterClick}
            />

            <ChipMenu
                value={filter.data?.state}
                items={stateFilterMenuItems}
                onClick={handleStateFilterClick}
            />
        </div>
    );
};

export default ListFilterDropdownButtonGroups;

type ListFilterDropdownButtonGroupsProps = {
    listId: string;
};
